export default __webpack_public_path__ + "static/media/IconDesc_HubParts.256.285ea5b0.png";